import { cn } from '@/utils';
import { isMobile } from '@/utils/mobile.util';
import { memo } from 'react';

import { isString } from 'ramda-adjunct';

export interface IRowItemProps {
	labelContainerClassName?: string;
	childrenClassName?: string;
	containerClassName?: string;
	label?: React.ReactNode;
	required?: boolean;
	children?: React.ReactNode;
	hidden?: boolean;
	horizontal?: boolean;
	disabled?: boolean;
	labelClassName?: string;
}

const RowItem = ({
	labelContainerClassName,
	childrenClassName,
	label,
	required,
	containerClassName,
	children,
	hidden,
	horizontal = false,
	disabled,
	labelClassName,
}: IRowItemProps) => {
	if (hidden) {
		return null;
	}

	return (
		<div
			className={cn(
				'flex gap-0 border-b last:border-b-0',
				containerClassName,
				horizontal && 'flex-col border-b-0 first:border-l-[1px]',
				disabled && 'bg-whiteSmoke xl:bg-white'
			)}
		>
			{label && (
				<div
					className={cn(
						' bg-zircon xl:bg-blue6 border-r-0 xl:border-r py-[14px] md:py-5 xl:py-[14.5px] px-[18px] md:px-[52px] xl:px-3 min-w-[27.778vw] w-[27.778vw] xl:w-auto xl:min-w-[180px]',
						labelContainerClassName
					)}
				>
					<label
						className={cn(
							'xl:h-4 block text-[13px] text-font3 leading-[15.5px]',
							labelClassName,
							isMobile && 'text-font2 text-[13px] md:text-[14px]'
						)}
					>
						{isString(label) ? (
							<>
								{label}
								{required && <span className="text-red6">*</span>}
							</>
						) : (
							label
						)}
					</label>
				</div>
			)}

			<div
				className={cn(
					'px-[10px] py-[7.5px] w-full h-full min-w-0 overflow-hidden',
					!isMobile && 'flex items-center',
					childrenClassName,
					horizontal && 'border-r border-t',
					'has-[.text-area]:overflow-visible'
				)}
			>
				{children}
			</div>
		</div>
	);
};

export default memo(RowItem);
